import { useUser } from 'features/auth/hooks';
import { useLoginWithNavigation } from 'features/auth/hooks/useLoginWithNavigation';
import { LoginContext } from 'features/auth/types';
import { SwitchCompanyForm } from 'features/auth/components/SwitchCompanyForm';

const SwitchCompany = () => {
  const { data } = useUser({});
  const { companySelect, selectCompany, handleLogout } = useLoginWithNavigation();

  const onSelectCompany = (loginContext: LoginContext, length: number) => {
    selectCompany(loginContext, data, length);
  };

  return (
    <SwitchCompanyForm
      onSelectCompany={onSelectCompany}
      onLogout={handleLogout}
      isLoading={companySelect.isPending}
    />
  );
};

export default SwitchCompany;
